import { useLanguage } from "../context/LanguageContext";
import { cvData } from "../data/cvData";
import LanguageToggle from "../components/LanguageToggle";
import HeroSection from "../components/HeroSection";
import CompetenciesSection from "../components/CompetenciesSection";
import ExperienceSection from "../components/ExperienceSection";
import EducationSection from "../components/EducationSection";
import SkillsSection from "../components/SkillsSection";
import ProjectsSection from "../components/ProjectsSection";
import Footer from "../components/Footer";

const CVPage = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="cv-page" className="min-h-screen bg-slate-50">
      <LanguageToggle />
      
      <main className="max-w-5xl mx-auto px-6 md:px-12">
        <HeroSection data={cvData} />
        <CompetenciesSection competencies={cvData.competencies} />
        <ProjectsSection projects={cvData.projects} />
        <ExperienceSection experience={cvData.experience} />
        <EducationSection education={cvData.education} />
        <SkillsSection skills={cvData.skills} />
      </main>

      <Footer contact={cvData.contact} pdfUrls={cvData.pdfUrls} />
    </div>
  );
};

export default CVPage;
